import { jsx as _jsx } from "react/jsx-runtime";
import { SearchLoupeIcon } from '@skbkontur/icons/icons/SearchLoupeIcon';
import { TrimmedInput } from './TrimmedInput';
export const TrimmedSearchInput = ({ placeholder = 'Поиск по ФИО или СНИЛС', debounce = 500, size, ...props }) => {
    return (_jsx(TrimmedInput, { leftIcon: _jsx(SearchLoupeIcon, { size: size === 'medium' ? 20 : 14 }), size: size, placeholder: placeholder, debounce: debounce, ...props }));
};
